export default __webpack_public_path__ + "static/media/Fleet-Commander-Game.118cd7e3.png";